<template>
    <Bar :id="id" :options="chartOptions" :data="chartData" style="position: relative;" :style="{ maxHeight: height, minHeight: height, width: width}">
    </Bar>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, SubTitle, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, SubTitle, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
import definition from '../data-definition';
export default {
    name: 'BarChart',
    components: { Bar },
    props: {
        id: String,
        data: Array,
        toUpper: Boolean,
        divideTitle: Boolean,
        responsive: {
            type: Boolean,
            default: true
        },
        xColor: {
            type: String,
            default: 'white'
        },
        inflationAdjustmentPeriods: {
            type: Array,
            default: () => []
        },
        height: {
            type: String,
            default: '260px'
        },
        width: {
            type: String,
            default: '300px'
        },
        titleColor: {
            type: String,
            default: ''
        },
        gradient: {
            type: Boolean,
            default: false
        },
        theme:  {
            type: String,
            default: ''
        },
        screenWidth:  {
            type: Number,
            default: 0
        },
        zeroPeriodForBarchart: {
            type: Boolean,
            default: false
        },
        xaxis: {
            type: Object,
            default: () => ({})
        },
        gridDisplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            labelDefinition: definition.labelDefinition,
        }
    },
    computed: {
        chartData() {
            return {
                labels: this.data.map(d => d.text),
                datasets: [{
                    data: this.data.map(d => {
                        if (this.zeroPeriodForBarchart && d.period == this.$store.state.ZERO_BARCHART_PERIOD) {
                            return 0;
                        }

                        const value = parseInt(d.value);
                        return value;
                    }),
                    backgroundColor: (ctx) => {
                        if (this.gradient) {
                            const canvas = ctx.chart.ctx;
                           
                            return this.data.map(d => {
                                const gradient = canvas.createLinearGradient(0, 0, 0, 220);
                                if (this.inflationAdjustmentPeriods?.includes(d.text)) {
                                    gradient.addColorStop(.5, '#eeee07');
                                    gradient.addColorStop(1, this.theme === 'dark-theme' ? '#5a5a04' : '#eaeaaa');
                    
                                    return gradient;
                                } else {
                                    if (d.value >= 0) {
                                        gradient.addColorStop(.5, '#00CD00');
                                        gradient.addColorStop(1, this.theme === 'dark-theme' ? '#123E24' : '#dfe7df');
                        
                                        return gradient;
                                    } else {
                                        gradient.addColorStop(.5, this.theme === 'dark-theme' ? '#5a1504' : '#eacbc3');
                                        gradient.addColorStop(1, '#F63200');
                    
                                        return gradient;
                                    }
                                }
                            });
                        } else {
                            return this.data.map(d => this.inflationAdjustmentPeriods?.includes(d.text) ? '#eeee07' : (d.value >= 0 ? '#00CD00' : '#F63200'))
                        }
                    },
                    color: '#f21d1d',
                    borderRadius: 5
                }]
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 10
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            title: context => {
                                const label = context[0]?.label;
                                const hasException = this.inflationAdjustmentPeriods?.includes(label);
                                return `${label}${ hasException ? ` - ${this.labelDefinition.inflationAdjustment[this.$store.state.lang]}` : ''}`;
                            }
                        }
                    },
                    legend: {
                        display: false
                    },
                    subtitle: {
                        display: false
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            display: false,
                            color: this.xColor
                        },
                        grid: {
                          display: this.gridDisplay,
                          color: this.theme === 'dark-theme' ? 'rgba(141,140,142,0.2)' : '#d4d2d6'
                        },
                        border: {
                          display: false
                        }
                    },
                    x: {
                        ticks: { 
                            color: this.getCssVar('--main-title-color'),
                            font: {
                                weight: this.xaxis?.weight || 600,
                                family: 'Poppins',
                                size: this.xaxis?.size || '12px',
                                lineHeight: 1
                            },
                            maxRotation: 0,
                            minRotation: 0
                         },
                         grid: {
                          display: false
                        },
                        border: {
                          display: true,
                          color: this.getCssVar('--main-title-color'),
                          width: 0.5
                        }
                    }
                }
            }
        }
    },
    methods: {
        getTitleList(text) {
            const texts = text.split(' ');
            const center = parseInt(texts.length / 2);
            return [texts.slice(0, center).join(' '), texts.slice(center).join(' ')];
        },
        formatThousand(value) {
           value = value ? value.toString() : '0';
           var pattern = /(-?\d+)(\d{3})/;
           while (pattern.test(value))
             value = value.replace(pattern, "$1.$2");
           return value;
        },
        getCssVar(name) {
            const el = document.getElementById('app')
            return getComputedStyle(el).getPropertyValue(name).trim()
        }
    }
}
</script>